export default "__VITE_ASSET__$RJgbKA$__"